var moment = require('moment-timezone');

// Add moment.js to the prototype
Vue.prototype.moment = moment;

// Add our (type aware) environment settings to the prototype
Vue.prototype.environment_settings = window.environment_settings;

//console.log(JSON.stringify(Vue.prototype.environment_settings));

if (!String.prototype.basename) {
    String.prototype.basename = function() {
        return this.substr(this.lastIndexOf("/") + 1);
    }
}

if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (this.length > targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
        }
    };
}

// polyfill for find(). Taken from:
// https://stackoverflow.com/questions/37788536/object-doesnt-support-property-or-method-find-in-ie

if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value: function (callback, type, quality) {
      var dataURL = this.toDataURL(type, quality).split(',')[1];
      setTimeout(function() {

        var binStr = atob( dataURL ),
            len = binStr.length,
            arr = new Uint8Array(len);

        for (var i = 0; i < len; i++ ) {
          arr[i] = binStr.charCodeAt(i);
        }

        callback( new Blob( [arr], {type: type || 'image/png'} ) );

      });
    }
  });
}

// Production steps of ECMA-262, Edition 5, 15.4.4.21
// Reference: http://es5.github.io/#x15.4.4.21
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
if (!Array.prototype.reduce) {
  Object.defineProperty(Array.prototype, 'reduce', {
    value: function(callback /*, initialValue*/) {
      if (this === null) {
        throw new TypeError( 'Array.prototype.reduce ' +
          'called on null or undefined' );
      }
      if (typeof callback !== 'function') {
        throw new TypeError( callback +
          ' is not a function');
      }

      // 1. Let O be ? ToObject(this value).
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // Steps 3, 4, 5, 6, 7
      var k = 0;
      var value;

      if (arguments.length >= 2) {
        value = arguments[1];
      } else {
        while (k < len && !(k in o)) {
          k++;
        }

        // 3. If len is 0 and initialValue is not present,
        //    throw a TypeError exception.
        if (k >= len) {
          throw new TypeError( 'Reduce of empty array ' +
            'with no initial value' );
        }
        value = o[k++];
      }

      // 8. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kPresent be ? HasProperty(O, Pk).
        // c. If kPresent is true, then
        //    i.  Let kValue be ? Get(O, Pk).
        //    ii. Let accumulator be ? Call(
        //          callbackfn, undefined,
        //          « accumulator, kValue, k, O »).
        if (k in o) {
          value = callback(value, o[k], k, o);
        }

        // d. Increase k by 1.
        k++;
      }

      // 9. Return accumulator.
      return value;
    }
  });
}

if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource !== null && nextSource !== undefined) {
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

if (!Uint8Array.prototype.reduce) {
    Object.defineProperty(Uint8Array.prototype, 'reduce', {
      value: function(callback /*, initialValue*/) {
        if (this === null) {
          throw new TypeError( 'Array.prototype.reduce ' +
            'called on null or undefined' );
        }
        if (typeof callback !== 'function') {
          throw new TypeError( callback +
            ' is not a function');
        }

        // 1. Let O be ? ToObject(this value).
        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // Steps 3, 4, 5, 6, 7
        var k = 0;
        var value;

        if (arguments.length >= 2) {
          value = arguments[1];
        } else {
          while (k < len && !(k in o)) {
            k++;
          }

          // 3. If len is 0 and initialValue is not present,
          //    throw a TypeError exception.
          if (k >= len) {
            throw new TypeError( 'Reduce of empty array ' +
              'with no initial value' );
          }
          value = o[k++];
        }

        // 8. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kPresent be ? HasProperty(O, Pk).
          // c. If kPresent is true, then
          //    i.  Let kValue be ? Get(O, Pk).
          //    ii. Let accumulator be ? Call(
          //          callbackfn, undefined,
          //          « accumulator, kValue, k, O »).
          if (k in o) {
            value = callback(value, o[k], k, o);
          }

          // d. Increase k by 1.
          k++;
        }

        // 9. Return accumulator.
        return value;
      }
    });
  }

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}

if (!String.prototype.repeat) {
    String.prototype.repeat = function(count) {
        'use strict';
        if (this == null) {
            throw new TypeError('can\'t convert ' + this + ' to object');
        }
        var str = '' + this;
        // To convert string to integer.
        count = +count;
        if (count != count) {
            count = 0;
        }
        if (count < 0) {
            throw new RangeError('repeat count must be non-negative');
        }
        if (count == Infinity) {
            throw new RangeError('repeat count must be less than infinity');
        }
        count = Math.floor(count);
        if (str.length == 0 || count == 0) {
            return '';
        }
        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28) {
            throw new RangeError('repeat count must not overflow maximum string size');
        }
        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while (count) {
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    }
}

if (!Math.sign) {
    Math.sign = function(x) {
        // If x is NaN, the result is NaN.
        // If x is -0, the result is -0.
        // If x is +0, the result is +0.
        // If x is negative and not -0, the result is -1.
        // If x is positive and not +0, the result is +1.
        return ((x > 0) - (x < 0)) || +x;
        // A more aesthetical persuado-representation is shown below
        //
        // ( (x > 0) ? 0 : 1 )  // if x is negative then negative one
        //          +           // else (because you cant be both - and +)
        // ( (x < 0) ? 0 : -1 ) // if x is positive then positive one
        //         ||           // if x is 0, -0, or NaN, or not a number,
        //         +x           // Then the result will be x, (or) if x is
        //                      // not a number, then x converts to number
    };
}

if (!Object.values) {
    Object.values = o=>Object.keys(o).map(k=>o[k]);
}

if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, pos) {
            pos = !pos || pos < 0 ? 0 : +pos;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

if (!String.prototype.endsWith) {
	String.prototype.endsWith = function(search, this_len) {
		if (this_len === undefined || this_len > this.length) {
			this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	};
}

Vue.prototype.canClose = () => {return true};

Vue.prototype.injectFieldErrors = function(field, messages) {
    this.errors = {};
    this.errors[field] = messages;
}

Vue.prototype.handleError = function(error, action, redirectPath) {
    console.log("Handling error: ");
    //console.log(JSON.stringify(error));
    console.log(error);
    //console.trace();

    if(typeof error == "object" && error.response) {
        if(error.response.status == 401) {
            // We silently ignore these as they will be picked up by the default axios error handler
        }
        else if(error.response.status == 410) {
            this.$root.deInitEcho();
            this.setLoading(true);
            this.addNotification({type: "danger", key: 'modsec', timeout: 0, html: true,
                content: this.$t('errors.application_version_too_old')});
            //window.location.reload(true);
        }
        else if(error.response.status == 429) {
            if(error.response.data.errors instanceof Object && typeof this.errors !== 'undefined') {
                this.errors = error.response.data.errors;
            }
            else {
                this.addNotification({type: "danger", content: this.$t('errors.too_many_page_requests')});
            }
        }
        else if(error.response.status == 403 && typeof error.response.data.message !== 'undefined') {
            this.addNotification({type: "danger", content: error.response.data.message});
            //this.errors = {"global": [error.response.data.message]};
        }
        else if(error.response.status == 413
                || (typeof error.response.data.exception !== 'undefined'
                    && error.response.data.exception == 'Illuminate\\Http\\Exceptions\\PostTooLargeException')) {
            this.addNotification({type: "danger", content: this.$t('errors.data_sending_too_large_rejected')});
        }

        else if(error.response.data.errors instanceof Object) {
            this.errors = error.response.data.errors;
        }
        else if(typeof error.response.data.type !== 'undefined') {
            switch(error.response.data.type) {
                case "ModelNotFoundException":
                    this.addNotification({type: "danger", timeout: 0, content: this.$t('errors.item_requested_not_found_maybe_deleted_by_another')});
                    if(redirectPath) {
                        this.$router.push({"path": redirectPath});
                    }
                    break;
                case "NotFoundHttpException":
                    this.addNotification({type: "danger", content:  this.$t('errors.data_endpoint_not_found')});
                    if(redirectPath) {
                        this.$router.push({"path": redirectPath});
                    }
                    break;
            }
            //this.errors = {"global":["An error occurred. Please try again."]};

        }
        else if(typeof error.response.data.message !== 'undefined') {
            //this.errors = {"global":[error.response.data.message]};

            // @todo We need to do something better here, but we can't really display the laravel messages
            // as it could contains sensitive information about the database structure.
            //
            this.addNotification({type: "danger", content: this.$t('errors.an_error_occured_try_again'), /*debug: JSON.stringify(error.response, null, 2)*/});
            if(window.errorReportCount < window.maxErrorReports) {
                window.errorReportCount++;

                var reportData = {
                    navigator: navigator.userAgent,
                    uri: window.location.href,
                    msg: JSON.stringify(error.response, null, 2),
                    error_report_subject: "report from handleError()",
                    routeHistory: window.routeHistory,
                    //trace: null; //this.stacktrace;
                }

                if(window.environment_settings.MIX_HANDLE_ERRORS) {
                    axios.post('/api/v0/error', reportData).then((res) => {
                    }).catch((error) => {
                    });
                }
            }
            // this.$bus.$emit('global-message-add', {
            //     messages: [{type: "danger", content: error.response.data.message}]
            // });
        }
        // Modsecurity will either return a 403 or a 406, and will not have any JSON
        // data in the response, just HTML. So it isn't 100% that this is a modsecurity issue
        // but it doesn't do any harm to show this message, and it means we get notified so
        // we can check it out.
        else if(error.response.status == 406 || error.response.status == 403) {
            this.addNotification({type: "danger", key: 'modsec', timeout: 0, html: true,
                content: this.$t('errors.security_risk')});
            //this.errors = {"global": [error.response.data.message]};
            var reportData = {
                navigator: navigator.userAgent,
                uri: window.location.href,
                msg: "Modsecurity block sending to: " + error.config.url,
                //error_report_subject: "modsecurity",
                routeHistory: window.routeHistory,
                //trace: null; //this.stacktrace;
                error_report_subject: "modsecurity - JavaScript error - handleError/HTTP",
            }

            if(window.environment_settings.MIX_HANDLE_ERRORS) {
                axios.post('/api/v0/error', reportData).then((res) => {
                }).catch((error) => {
                });
            }
        }

        else {
            this.addNotification({type: "danger", content: this.$t('errors.unexpected_response_from_server')});
        }
    }
    else if(error instanceof Error) {
        // Request aborted messages occur when navigating away from the app sometimes
        // especially for custom action URLs, so we can ignore those.
        //console.error(error);
        if(error.message != "Request aborted") {
            this.addNotification({type: "danger", content: error.message});
        }
    }
    else {
        // this.$bus.$emit('global-message-add', {
        //     messages: [{type: "danger", content: "Failed to " + action + ": " + error.message}]
        // });
    }
};

Vue.prototype.setLoading = function(status, message) {
    if(this.$refs.loading) {
        if(status) {
            this.$refs.loading.message = message;
            this.$refs.loading.$refs.spinnerContainer.style.display = "block";
            if(this.$refs["container"]) {
                this.$refs["container"].style.opacity = 0.5;
            }
        }
        else {
            this.$refs.loading.message = null;
            this.$refs.loading.$refs.spinnerContainer.style.display = "none";
            if(this.$refs["container"]) {
                this.$refs["container"].style.opacity = 1;
            }
        }
    }
    // else {
    //     try{
    //         if(status) {
    //             if(this.$refs.spinnerContainer) {
    //                 this.$refs.spinnerContainer.style.display = "block";
    //             }
    //             if(this.$refs["container"]) {
    //                 this.$refs["container"].style.opacity = 0.5;
    //             }
    //         }
    //         else {
    //             if(this.$refs.spinnerContainer) {
    //                 this.$refs.spinnerContainer.style.display = "none";
    //             }
    //             if(this.$refs["container"]) {
    //                 this.$refs["container"].style.opacity = 1;
    //             }
    //         }
    //     }
    //     catch(e) {
    //         console.log(e);
    //         console.trace();
    //     }
    // }
    else if(this.$parent && this.$parent != this) {
        this.$parent.setLoading(status, message);
    }
};

Vue.prototype.is_superuser = function(user) {
    if(typeof user == "undefined") {
        user = this.$root.user;
    }
    return (user.provider.user_role_id == this.$root.lookup.user_roles.Superuser);
};


Vue.prototype.is_admin = function(user) {
    if(typeof user == "undefined") {
        user = this.$root.user;
    }
    return user.provider.user_role_id == this.$root.lookup.user_roles.Admin;
};

Vue.prototype.is_user = function(user) {
    if(typeof user == "undefined") {
        user = this.$root.user;
    }
    return user.provider.user_role_id == this.$root.lookup.user_roles.User;
};

Vue.prototype.is_robot = function(user) {
    if(typeof user == "undefined") {
        user = this.$root.user;
    }
    return (user ? user.user_type_id == 1 : false);
};


Vue.prototype.is_staff = function(user) {
    if(typeof user == "undefined") {
        user = this.$root.user;
    }
    return (user ? user.user_type_id == 2 : false);
};

Vue.prototype.is_patient = function(user) {
    if(typeof user == "undefined") {
        user = this.$root.user;
    }
    return (user ? user.user_type_id == 3 : false);
};

Vue.prototype.is_network_admin = function(user) {
    if(typeof user == "undefined") {
        user = this.$root.user;
    }
    return (user ? user.user_type_id == 4 : false);
};

Vue.prototype.is_logged_in = function() {
    if(typeof this.$root.api_token == "undefined" || this.$root.api_token == null) {
        return false;
    }
    return true;
};

Vue.prototype.nameLookupById = function(lookup, value) {
    var obj = lookup;
    if(typeof lookup == "string") {
        obj = this.$root.lookup[lookup];
    }

    for(var key in obj) {
        if (obj.hasOwnProperty(key)) {
            if(obj[key] == value) {
                return key;
            }
        }
    }
};

Vue.prototype.formatDateTime = function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm');
    }
};

Vue.prototype.formatDate = function(value) {
    if (value) {
        var date = moment(String(value));
        if(date.isValid()) {
            return date.format('DD/MM/YYYY');
        }
        else {
            return value;
        }

    }
};

Vue.prototype.formatShortTime = function(value) {
    if (value) {
        return moment("1900-01-01 " + String(value)).format('HH:mm');
    }
};

Vue.prototype.capitalise = function(value) {
    if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}

Vue.prototype.titleCase = (value) => {
    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  

Vue.prototype.formatName = function(user, provider_name = null) {
    var name = "";

    if(user && user.surname && user.forenames) {
        name += user.forenames + " " + user.surname;
    }
    if(provider_name) {
        name += ", " + provider_name;
    }
    return name;
}

Vue.prototype.formatClinician = function(user) {
    var name = "";

    if(user) {
        var name = this.formatName(user);

        if(user.profession) {
            name += ", " + user.profession;
        }
        if(user.gender) {
            name += " (" + user.gender + ")";
        }
        if(user.alias) {
            name = user.alias;
        }
    }

    return name;
}

Vue.prototype.isPositiveInteger = function(n) {
    return n >>> 0 === parseFloat(n);
},

// @SYNC Thread.php
Vue.prototype.isMultiProviderThread = function(thread, messages = null) {
    if(thread) {
        if(thread.thread_provider_xref && thread.thread_provider_xref.length > 1) {
            return true;
        }
    
        // Special case for when a request has been shared, and then unshared.
        if(messages) {
            for(index in messages) {
                if(messages[index].provider_id != thread.owner_provider_id) {
                    return true;
                }
            }
        }
    }
    return false;
},

// @SYNC User.php
Vue.prototype.formatNameWithProvider = function(user, provider, thread, messages = null) {
    var name = "";
    
    // For patients we prefix with "Patient: "
    if(!this.is_patient() && this.isMultiProviderThread(thread, messages) && this.is_patient(user)) {
        name += "Patient: ";
    }

    if(this.is_patient()) {
        if(user.alias) {
            name += user.alias;
        }
        else {
            name += this.formatName(user);
        }
        if(user.profession) {
            name += ", " +  user.profession;
        }
    }
    else {
        name += this.formatName(user);
        if(user.alias) {
            name += " (" + user.alias + ")"
        }
    }

    // Only if not a patient we suffix with the provider name
    if(this.isMultiProviderThread(thread, messages) && !this.is_patient(user)) {
        // Filter out the provider name when the robot has the same name as the provider
        if(this.is_robot(user) && provider.name == this.formatName(user)) {
            // Special case this. Currently we set up Provider A to have a robot called "Provider A",
            // so this renders as "Provider A, Provider A wrote". But for some providers we suggested
            // using a more generic "Your Provider", but then that wouldnt give us a clue on its own
            // as to which robot it was that did it, so we filter only when the names match, and 
            // would currently get "Your Provider, Provider A" which isn't great, but provides all
            // the info for a multi-provider request.
        }
        else {
            name += ", " + provider.name;
        }
    }
    
    return name;
},

Vue.prototype.formatNameWithTitle = function(user) {
    var name = "";
    if(user) {
        if((!this.is_logged_in() || this.is_patient()) && user.alias) {
            return user.alias;
        }
        if(user.user_title_id) {
            name += this.$root.lookup.user_titles[user.user_title_id] + " ";
        }
        name += this.formatName(user);
    }
    return name;
}

Vue.prototype.formatSurname = function(user) {
    if(user) {
        if((!this.is_logged_in() || this.is_patient()) && user.alias) {
            return user.alias;
        }
        if(user.surname && user.forenames) {
            return user.surname.toUpperCase() + " " + user.forenames;
        }
    }
    return '';
}

Vue.prototype.formatNameCompliant = function(user) {
    if(user && user.surname && user.forenames) {
        return user.surname.toUpperCase() + ", " + user.forenames + (user.user_title_id ? " (" + this.$root.lookup.user_titles[user.user_title_id] + ")" : "");
    }
    return '';
}

// @SYNC Security.php
Vue.prototype.formatContent = function(content, defang) {

    if(content && typeof content == "string") {

        if(defang) {
            content = content.replace(/</g, "&lt;");
            //var regex = /((http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/=!]*)[^?.,! \n])/gi;
            var regex = /(((x-)?safari-)?(https?:\/\/[-a-zA-Z0-9@:%_.\+~#=]+\.[-a-zA-Z0-9]{2,6}([-a-zA-Z0-9()@:%_\+.~#?&\/=!]*[^?.:,! \n])?))/gi;
            content = content.replace(regex,
                "<a style='color: inherit; text-decoration: underline;' target='messagelink' href='$1'>$4</a>");
            
        }
        content = content.trim().replace(/\\n/g, "<br />").replace(/\n/g, "<br />");
        // Defang any html in the content
        
    }
    return content;
}

Vue.prototype.isIsoWeekday = function(date_spec) {
    return(date_spec >= 1 && date_spec <= 7);
}

Vue.prototype.getAvailability = function(availability, date_spec) {
    if(this.isIsoWeekday(date_spec)) {
        return availability.find(obj => {return obj.day_of_week == date_spec});
    }
    return availability.find(obj => {return obj.date_from == date_spec});
}


Vue.prototype.getAvailabilityIndexes = function(availability, date_spec) {
    if(this.isIsoWeekday(date_spec)) {
        return availability.reduce((c,v,i) => v.day_of_week == date_spec ? c.concat(i) : c, []);
    }
    return availability.reduce((c,v,i) => v.date_from == date_spec ? c.concat(i) : c, []);
}

Vue.prototype.getAvailabilityExceptionIndexes = function(availability) {
    return availability.reduce((c,v,i) => v.date_from !== null ? c.concat(i) : c, []);
}


Vue.prototype.getTimeRange = function(time) {
    if(time.from) {
        return this.formatShortTime(time.from) + " - " + this.formatShortTime(time.to);
    }
    return "";
}

Vue.prototype.getTimeRanges = function(times) {
    var timeString = "";
    if(times.length) {
        times.forEach((elem) => {
            if(timeString.length) {
                timeString += "<br>";
            }
            timeString += this.getTimeRange(elem);
        })
    }
    return timeString;
}

Vue.prototype.getAvailabilityFormatted = function(availability, date_spec, none_text) {
    var date = this.getAvailability(availability, date_spec);
    if(date) {
        time_range = this.getTimeRanges(date.availability_time);
        if(time_range) {
            return time_range;
        }
    }
    return none_text;
}

Vue.prototype.setAvailability = function(item, look_ahead, look_ahead_hours, site_specific = true) {

    var start_offset = 0;
    do {
        var date = moment().tz(this.$root.provider.timezone).add(this.$root.minuteOffset, 'minutes').add(start_offset, "days");
        var day = date.format("YYYY-MM-DD");
        //var weekDay = moment().isoWeekday();
        var weekDay = date.isoWeekday();

        // @todo This is horrible. Double setting this value. Very confusing. Rewrite this.
        date = moment();

        //console.log("date: " + date);

        //console.log("weekDay: " + weekDay);

        //console.log("time: " + time);

        //console.log("day: " + day);

        //console.log(JSON.stringify(item));

        // Check for specific dates first

        if(Array.isArray(item.availability_date)) {
            //console.log("item Availability: " + JSON.stringify(item.availability_date, null,  2));

            // EXCEPTIONS
            var availability_dates = item.availability_date.filter(obj => {
                if(obj.date_from) {
                    if((obj.date_to && obj.date_from <= day && obj.date_to >= day)
                            || (!obj.date_to && obj.date_from == day)) {
                        return obj.availability_time.find(availability_time => {return !site_specific || this.isCurrentProviderSite(availability_time.site_id)});
                    }
                    //return obj.date_to ? (obj.date_from <= day && obj.date_to >= day) : (obj.date_from == day) 
                }
                return false;
            });
            //console.log("item Availability: " + JSON.stringify(availability_dates, null,  2));
            if(availability_dates.length) {
                for(date_index in availability_dates) {
                    if(Array.isArray(availability_dates[date_index].availability_time)) {

                        for(var index in availability_dates[date_index].availability_time) {
                            if(!availability_dates[date_index].availability_time[index].from) {
                                //console.log("Empty availability. Returning false.")
                                item.available = false;
                                return item.available;
                            }
                            else if(date.isAfter(moment.tz(day + " " + availability_dates[date_index].availability_time[index].from, this.$root.provider.timezone).subtract(look_ahead_hours, "hours"))
                            && date.isBefore(moment.tz(day + " " + availability_dates[date_index].availability_time[index].to, this.$root.provider.timezone))) {
                                //console.log("Got availability in exception. Returning true.")
                                item.available = true;
                                return item.available;
                            }
                        }
                    }
                }
                // If we can't find a matching time range, but there is an exception set for today,
                // then the exception applies over the rest of the
                // day so the item is unavailable, and we don't want to fall back to the standard days below.
                
                item.available = false;
                return item.available;
            }
            // STANDARD DAYS
            availability_dates = item.availability_date.filter(obj => {return obj.day_of_week == weekDay});
            //console.log("item Availability: " + JSON.stringify(availability_dates));
            for(date_index in availability_dates) {
                if(Array.isArray(availability_dates[date_index].availability_time)) {
                    //console.log("1");
                    for(var index in availability_dates[date_index].availability_time) {
                        if(!site_specific || this.isCurrentProviderSite(availability_dates[date_index].availability_time[index].site_id)) {
                            if(!availability_dates[date_index].availability_time[index].from) {
                                item.available = false;
                                return item.available;
                            }
                            // if(item.id === 1) {
                            //     console.log("CHECKING: " + JSON.stringify(availability_dates[index]));
                            //     console.log(date.format("YYYY-MM-DD HH:mm"));
                            //     console.log(moment(day + " " + availability_dates[date_index].availability_time[index].from).subtract(14, "hours").format("YYYY-MM-DD HH:mm"));
                            // }
                            //console.log(this.formatName(item) + ") Checking if " + date.format(moment.HTML5_FMT.DATETIME_LOCAL) + " is between " + moment(day + " " + availability_dates[date_index].availability_time[index].from).subtract(14, "hours").format(moment.HTML5_FMT.DATETIME_LOCAL) + " and " + moment(day + " " + availability_dates[date_index].availability_time[index].to).format(moment.HTML5_FMT.DATETIME_LOCAL));
                            if(date.isAfter(moment.tz(day + " " + availability_dates[date_index].availability_time[index].from, this.$root.provider.timezone).subtract(look_ahead_hours, "hours"))
                            && date.isBefore(moment.tz(day + " " + availability_dates[date_index].availability_time[index].to, this.$root.provider.timezone))) {
                                //console.log("Got availability in standard day of week. Returning true.")
                                item.available = true;
                                return item.available;
                            }
                        }
                    }
                }
            }
        }
        start_offset++;
    } while(start_offset <= look_ahead)
    //console.log("No availability found. Returning false.")
    item.available = false;
    return item.available;
}


Vue.prototype.isCurrentProviderSite = function(site_id, sites) {
    if(typeof sites == "undefined") {
        sites = this.$root.provider.site;
    }
    return sites.find(site => {return site.id == site_id});
},

// @sync Provider.php:isAvailable()
Vue.prototype.setServiceStatus = function() {
    if(this.$root.provider && (this.$root.provider.service_status == 0 || this.$root.provider.network_service_status == 0)) {
        this.$root.provider.calc_service_status = this.$root.lookup.service_status.OFFLINE;
        return this.$root.provider.calc_service_status;
    }
    //alert("REMOVE DEBUG!!!!!");
    var date = moment().tz(this.$root.provider.timezone).add(this.$root.minuteOffset, 'minutes');
    var weekDay = date.isoWeekday();
    var day = date.format("YYYY-MM-DD");
    
    if(Array.isArray(this.$root.provider.availability_date)) {
        //console.log("User Availability: " + JSON.stringify(this.$root.provider.availability_date, null,  2));

        var availability_dates = this.$root.provider.availability_date.filter(obj => {return obj.date_to ? (obj.date_from <= day && obj.date_to >= day) : (obj.date_from == day) });
        //console.log("User Availability: " + JSON.stringify(availability_dates, null,  2));
        for(var date_index in availability_dates) {
            if(Array.isArray(availability_dates[date_index].availability_time)) {

                for(var index in availability_dates[date_index].availability_time) {
                    if(!availability_dates[date_index].availability_time[index].from) {
                        //console.log("Empty availability. Returning false.")
                        this.$root.provider.calc_service_status = this.$root.lookup.service_status.OOH_UNAVAILABLE;
                        return this.$root.provider.calc_service_status;
                    }
                    else if(date.isAfter(moment.tz(day + " " + availability_dates[date_index].availability_time[index].from, this.$root.provider.timezone))
                    && date.isBefore(moment.tz(day + " " + availability_dates[date_index].availability_time[index].to, this.$root.provider.timezone))) {
                        //console.log("Got availability in exception. Returning true.")
                        this.$root.provider.calc_service_status = this.$root.lookup.service_status.AVAILABLE;
                        return this.$root.provider.calc_service_status;
                    }
                }
            }
        }
        availability_dates = this.$root.provider.availability_date.filter(obj => {return obj.day_of_week == weekDay});
        //console.log("User Availability: " + JSON.stringify(availability_dates));
        for(var date_index in availability_dates) {
            if(Array.isArray(availability_dates[date_index].availability_time)) {
                    // && availability_dates[date_index].availability_time.length
                    // && availability_dates[date_index].availability_time[0].from
                    // && availability_dates[date_index].availability_time[0].to) {
                for(var index in availability_dates[date_index].availability_time) {
                    //console.log("CHECKING: " + JSON.stringify(availability[index]));
                    if(date.isAfter(moment.tz(day + " " + availability_dates[date_index].availability_time[index].from, this.$root.provider.timezone))
                    && date.isBefore(moment.tz(day + " " + availability_dates[date_index].availability_time[index].to, this.$root.provider.timezone))) {
                        //console.log("Got availability in standard day of week. Returning true.")
                        this.$root.provider.calc_service_status = this.$root.lookup.service_status.AVAILABLE;
                        return this.$root.provider.calc_service_status;
                    }
                }
            }
            // // If there are no opening hours at all set for the day in question, then we use the current days OOH settings
            // else {
            //     if(availability_dates[date_index].available_ooh) {
            //         this.$root.provider.calc_service_status = this.$root.lookup.service_status.OOH_AVAILABLE;
            //         return this.$root.provider.calc_service_status;
            //     }
            //     else {
            //         this.$root.provider.calc_service_status = this.$root.lookup.service_status.OOH_UNAVAILABLE;
            //         return this.$root.provider.calc_service_status;
            //     }
            // }
        }

        // Finally we check what setting we should use for OOH. Stepping back through the week
        // until we find a day with opening hours that we are beyond the end of.
        var closed_index = null;
        var date2 = moment().tz(this.$root.provider.timezone).add(this.$root.minuteOffset, 'minutes');
    
        for(var daySearch = 0; daySearch < 7 && closed_index === null; daySearch++) {

            var day2 = date2.format("YYYY-MM-DD");
            var weekDay2 = date2.isoWeekday();

            availability_dates = this.$root.provider.availability_date.filter(obj => {return obj.day_of_week == weekDay2});
            //console.log("User Availability: " + JSON.stringify(availability_dates));
            for(var date_index in availability_dates) {
                if(Array.isArray(availability_dates[date_index].availability_time) && availability_dates[date_index].availability_time.length && availability_dates[date_index].availability_time[0].to) {
                    for(var index in availability_dates[date_index].availability_time) {
                        if(date.isAfter(moment.tz(day2 + " " + availability_dates[date_index].availability_time[index].to, this.$root.provider.timezone))) {
                            closed_index = date_index;
                        }
                    }
                }
            }
            date2.subtract(1, "days");
        }
        if(closed_index !== null && availability_dates[closed_index].available_ooh) {
            this.$root.provider.calc_service_status = this.$root.lookup.service_status.OOH_AVAILABLE;
            return this.$root.provider.calc_service_status;
        }
        else {
            this.$root.provider.calc_service_status = this.$root.lookup.service_status.OOH_UNAVAILABLE;
            return this.$root.provider.calc_service_status;
        }
    }
    //console.log("No availability found. Returning false.")
    this.$root.provider.calc_service_status = this.$root.lookup.service_status.OOH_UNAVAILABLE;
    return this.$root.provider.calc_service_status;
}

Vue.prototype.outOfHoursCustomActions = function() {
    return this.$root.provider.custom_action.filter(obj => {return obj.allow_out_of_hours && this.$root.provider.calc_service_status == this.$root.lookup.service_status.OOH_UNAVAILABLE});
}

Vue.prototype.isOohUnavailable = function() {
    return this.$root.provider.calc_service_status == this.$root.lookup.service_status.OOH_UNAVAILABLE;
}

Vue.prototype.serviceAvailabliltyMessage = function() {
    var message = this.$root.provider.name + " ";
    if(this.isOohUnavailable() && this.outOfHoursCustomActions().length) {
        message += this.autobrand('translations.is_currently_available_for_some_requests');
    }
    else {
        message += this.autobrand('translations.is_currently_unavailable_for_online_requests')
    }
    return message;
}

Vue.prototype.isServiceAvailable = function() {
    // If we don't know what provider the user is with yet, then we allow them
    // to continue until they login, or register (although they can't register
    // if we don't know their provider just yet).
    if(!this.$root.provider) {
        return true;
    }
    switch(this.$root.provider.calc_service_status) {
        case this.$root.lookup.service_status.OOH_UNAVAILABLE:
        case this.$root.lookup.service_status.OFFLINE:
            return false;
    }
    return true;
}

Vue.prototype.formatAddress = function(address_line_1, address_line_2, address_line_3, address_line_4, postcode) {
    var address = "";
    if(address_line_1) {
        address += address_line_1;
    }
    if(address_line_2) {
        if(address != "") {
            address += ", ";
        }
        address += address_line_2;
    }
    if(address_line_3) {
        if(address != "") {
            address += ", ";
        }

        address += address_line_3;
    }
    if(address_line_4) {
        if(address != "") {
            address += ", ";
        }

        address += address_line_4;
    }
    if(postcode) {
        if(address != "") {
            address += ", ";
        }

        address += postcode;
    }
    return address == "" ? "[unknown]" : address;
};

Vue.prototype.getGender = function(value) {
    if (value) {
        return this.$root.lookup.genders[value];
    }
}

Vue.prototype.getSiteName = function(user) {
    if(this.$root.provider && this.$root.provider.site && user.provider) {
        var site = this.$root.provider.site.filter((obj) => {return obj.id == user.provider.site_id});
        if(site.length == 1) {
            return site[0].name;
        }
    }
    return "";
}

Vue.prototype.getSiteNameById = function(id, site_list, not_found_text) {

    if(typeof not_found_text == "undefined") {
        not_found_text = "";
    }

    if(typeof site_list == "undefined") {
        if(this.$root.provider && this.$root.provider.site) {
            site_list = this.$root.provider.site;
        }
        else return not_found_text;
    }

    
    var site = site_list.filter((obj) => {return (obj && obj.id) ? obj.id == id : false});
    if(site.length == 1) {
        return site[0].name;
    }

    return not_found_text;
}

Vue.prototype.getSites = function(provider_id) {

    var sites = [];

    if(provider_id) {
        if(this.$root.lookup.providers) {
            sites = this.$root.lookup.providers[provider_id].site;
        }
        else if(this.$root.user.provider.id == provider_id) {
            sites = this.$root.user.provider.site;
        }
    }
    else if(this.is_network_admin()) {
        for(var pIndex in this.$root.lookup.providers) {
            for(var index in this.$root.lookup.providers[pIndex].site) {
                sites = sites.concat(this.$root.lookup.providers[pIndex].site[index]);
            }
        }
    }
    else {
        for(var index in this.$root.user.user_provider) {
            sites = sites.concat(this.$root.user.user_provider[index].site);
        }
    }

    return sites.sort(function(a, b) {return a.name.localeCompare(b.name)});
}

Vue.prototype.getSitesFromUser = function(user, provider_id) {

    var sites = [];
    user.user_provider.filter(obj => {return (typeof provider_id == "undefined" || obj.id == provider_id)}).forEach(item => {
        sites = sites.concat(item.site);
    });

    return sites.sort(function(a, b) {return a.name.localeCompare(b.name)});
}


Vue.prototype.sortByValue = function(list, value = "name", sub = null) {
    if(Array.isArray(list)) {
        return list.slice(0).sort((a,b) => {
            if(sub) {
                return a[sub][value].localeCompare(b[sub][value]);    
            }
            else {
                return a[value].localeCompare(b[value]);
            }
        });
    }
    else if(typeof list == "object") {
        var arr = [];
        for (var prop in list) {
            if (list.hasOwnProperty(prop)) {
                arr.push(list[prop]);
            }
        }
        return arr.sort((a, b) =>  {
            if(sub) {
                return a[sub][value].localeCompare(b[sub][value]);    
            }
            else {
                return a[value].localeCompare(b[value]);
            }
        });
    }
}

Vue.prototype.sortByKey = function(object) {
    var ordered = {};
    Object.keys(object).sort().forEach(function(key) {
        ordered[key] = object[key];
    });
    return ordered;
}

Vue.prototype.getCaree = function(id) {
    if(this.$root.user && Array.isArray(this.$root.user.carees)) {
        return this.$root.user.carees.find((elem) => {
            return elem.id == id;
        });
    }
    return null;
}

Vue.prototype.copyNonReactive = function(obj) {
    return JSON.parse(JSON.stringify(obj));
}

Vue.prototype.mergeUpdateItem = function(item, update, ignore) {
    for (var attrname in update) {
        if(!ignore.find(value => {return attrname == value})) {
            //console.log("Setting: " + attrname + ")" + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
            item[attrname] = update[attrname];
        }
    }
}

Vue.prototype.formatNhsNumber = function(value) {
    var newValue = "";
    if(typeof(value) == "string" || typeof(value) == "number") {

        for(var index = 0; index < value.length; index++) {
            if(index == 3 || index == 6) {
                newValue += " ";
            }
            newValue += value[index];
        }
    }
    return newValue;
}

Vue.prototype.removeNotification = function(key) {
    for(var index in this.$root.notifications) {
        if(this.$root.notifications[index].key == key) {
            this.$root.notifications.splice(index, 1);
            break;
        }
    }
}

Vue.prototype.addNotification = function(notification) {
    if(typeof notification.timeout == "undefined") {
        notification.timeout = 4000;
    }
    if(typeof notification.dismissable == "undefined") {
        notification.dismissable = true;
    }

    if(notification.key) {
        for(var index in this.$root.notifications) {
            if(this.$root.notifications[index].key == notification.key) {
                clearTimeout(this.$root.notifications[index].timer);
                this.$root.notifications.splice(index, 1);

                break;
            }
        }
    }
    else {
        notification.key = this.$root.notifications.length;
    }
    //console.log("NEW NOTIFICATION: " + JSON.stringify(notification, null, 2));
    if(notification.top) {
        this.$root.notifications.unshift(notification);
    }
    else {
        this.$root.notifications.push(notification);
    }
    if(notification.timeout != 0) {
        notification.timer = setTimeout(() => {
            //console.log("REMOVE NOTIFICATION: " + JSON.stringify(notification, null, 2));
            for(var index in this.$root.notifications) {
                if(this.$root.notifications[index].key == notification.key) {
                    //console.log("FOUND NOTIFICATION: " + JSON.stringify(notification, null, 2));
                    // This is a horrible way to do the fadeOut. Switch to using the
                    // vuejs animation template (possibly with velocity.js)
                    $('#notification-' + notification.key).fadeOut(2000, () => {
                        // Have to use nextTick here to make sure the jQuery elements update before
                        // Vue refreshes.
                        Vue.nextTick(() => {
                            for(var index in this.$root.notifications) {
                                if(this.$root.notifications[index].key == notification.key) {
                                    //console.error(this.$root.notifications);
                                    //console.log("REMOVING NOTIFICATION: " + JSON.stringify(this.$root.notifications[index], null, 2));

                                    this.$root.notifications.splice(index, 1);

                                    //console.error(this.$root.notifications);
                                    break;
                                }
                            }
                        })
                    });

                    // We have to use a separate timer for the actual removal. Not sure why.
                    // Some kind of conflict between jQuery and Vue.
                    // setTimeout(() => {
                    //     for(var index in this.$root.notifications) {
                    //         if(this.$root.notifications[index].key == notification.key) {
                    //             //console.error(this.$root.notifications);
                    //             //console.log("REMOVING NOTIFICATION: " + JSON.stringify(this.$root.notifications[index], null, 2));

                    //             this.$root.notifications.splice(index, 1);

                    //             //console.error(this.$root.notifications);
                    //             break;
                    //         }
                    //     }

                    // }, 1800);
                    break;
                }
            }
        }, notification.timeout);
    }
},

Vue.prototype.getSetting = function(name, default_value) {
    if(typeof this.$root.user_settings[name] == "undefined" && typeof default_value !== "undefined") {
        return default_value;
    }
    return this.$root.user_settings[name];
}

Vue.prototype.setSetting = function(name, value) {
    this.$root.user_settings[name] = value;

    try {
        localStorage.setItem("user_settings_" + this.$root.user.id, JSON.stringify(this.$root.user_settings));
    }
    catch(e) {

    }

}

Vue.prototype.copyTextContent = function(html) {
    console.log('click');
    var container = document.createElement('div');
    container.innerHTML = html;
    document.body.appendChild(container);
    window.getSelection().removeAllRanges();
    var range = document.createRange();
    range.selectNode(container);
    window.getSelection().addRange(range);
    document.execCommand('copy');
    document.body.removeChild(container);
    this.addNotification({type: "success", content: html + ' ' + this.$t('translations.copied_to_clipboard')});
}

Vue.prototype.appointmentsEnabled = function() {
    //return this.environment_settings.MIX_ENABLE_VIDEO && this.$root.provider && this.$root.provider.appointment_booking_enabled;
    return this.$root.provider && this.$root.provider.appointment_booking_enabled;
}

//
// Vue.prototype.nickelledReady = function() {
//     //console.log("HERE!!!!!!!!!");
//     //console.log(typeof window.NickelledLaunchers);
//     if(typeof window.NickelledLaunchers === "object" &&  typeof window.NickelledLaunchers._init === "function") {
//         return true;
//     }
//     return false;
// }
//
// Vue.prototype.showNickelled = function() {
//     if(this.nickelledReady() && this.$root.user && this.$root.user.id) {
//         window.NickelledLaunchers.show();
//
//         return true;
//     }
//     return false;
// }


Vue.prototype.stacktrace = function() {
  function st2(f) {
    var args = [];
    if (f) {
        for (var i = 0; i < f.arguments.length; i++) {
            args.push(f.arguments[i]);
        }
        var function_name = f.toString().split('(')[0].substring(9);
        return st2(f.caller) + function_name + '(' + args.join(', ') + ')' + "\n";
    } else {
        return "";
    }
  }
  return st2(arguments.callee.caller);
}

Vue.prototype.reportError = function(subject, data) {
    if(window.errorReportCount < window.maxErrorReports) {
        window.errorReportCount++;
        var reportData = {
            navigator: navigator.userAgent,
            uri: window.location.href,
            data: data,
            error_report_subject: subject,
            routeHistory: window.routeHistory,
            //trace: null; //this.stacktrace;
        }
        axios.post('/api/v0/error', reportData).then((res) => {
        }).catch((error) => {
        });
    }
}

Vue.prototype.scrollFirstError = function() {
    Vue.nextTick(() => {
        let el = this.$el.querySelector("._error");
        //console.info(el);
        if(el) {
            if(el.parentElement) {
                if(el.parentElement.parentElement) {
                    el.parentElement.parentElement.scrollIntoView(true);
                }
                else {
                    el.parentElement.scrollIntoView(true);
                }
                //el.closest("label").scrollIntoView(true);
            }
            else {
                el.scrollIntoView(true);
            }
        }
    });
}

/**
 * [description]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */

Vue.filter('formatDate', function(value) {
    return Vue.prototype.formatDate(value);
});

Vue.filter('formatNameCompliant', function(user) {
    if(user && user.surname && user.forenames) {
        return user.surname.toUpperCase() + ", " + user.forenames + (user.user_title_id ? " (" + $root.lookup.user_titles[user.user_title_id] + ")" : "");
    }
    return '';
});

Vue.filter('formatDateTime', function(value) {
    return Vue.prototype.formatDateTime(value);
});

Vue.filter('formatDateTimeNullAware', function(value) {
    if(value) {
        return Vue.prototype.formatDateTime(value);
    }
    return "[not set]";
});


Vue.filter('formatShortTime', function(value) {
    return Vue.prototype.formatShortTime(value);
});

Vue.filter('capitalise', function(value) {
    return Vue.prototype.capitalise(value);
});

Vue.filter('titleCase', function(value) {
    return Vue.prototype.titleCase(value);
});


Vue.filter('getAge', function(value) {
    if (value) {
        if ( moment().diff(value, 'days') < 28 ) { // < 4 weeks in Days
            return moment().diff(value, 'days', false) + "d";
        }
        if ( moment().diff(value, 'weeks') < 52 ) { // < 1 year in Weeks
            return moment().diff(value, 'weeks', false) + "w";
        }
        if ( moment().diff(value, 'months', false) < 24 ) { // < 2 years in Months
            return moment().diff(value, 'months', false) + "m";
        }
        return moment().diff(value, 'years', false) + "y";
    }
});

Vue.prototype.excerpt = function(str, maxLen, separator = ' ') {
    if (str.length <= maxLen) return str;

    var excerpt = str.substr(0, str.lastIndexOf(separator, maxLen));
    if(excerpt.length == str.length) {
        return str;
    }
    return excerpt + " ...";
}

Vue.filter('excerpt', function(value) {
    return Vue.prototype.excerpt(value, 96);
});

Vue.filter('formatContent', function(value) {
    return Vue.prototype.formatContent(value, true);
});


Vue.filter('formatNhsNumber', function(value) {
    return Vue.prototype.formatNhsNumber(value);
});



Object.defineProperty(Object.prototype, 'getIndex', {
    value: function (query) {

        for (var key in this) {
            var value = this[key];

            if (value.toLowerCase() === query) {
                return key;
            }

        }
    }
});

/**
 * Quick and dirty hash code generator, will do for our requirements. Taken from here:
 *
 *   https://stackoverflow.com/questions/194846/is-there-any-kind-of-hash-code-function-in-javascript
 *
 * Not ideal, but it is smaller than a full md5 implementation.
 */
String.prototype.hashCode = function(){
    var hash = 0;
    for (var i = 0; i < this.length; i++) {
        var character = this.charCodeAt(i);
        hash = ((hash<<5)-hash)+character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}

Vue.prototype.completesOnBehalfOf = function(user) {
    if(typeof user == "undefined") {
        user = this.$root.user;
    }

    for(var index in this.$root.lookup.user_groups) {
        if(this.$root.lookup.user_groups[index].completes_on_behalf_of) {
            for(var userIndex in this.$root.lookup.user_groups[index].usersusergroup) {
                if(this.$root.lookup.user_groups[index].usersusergroup[userIndex].user_id == user.id) {
                    return true;
                }
            }
        }
    }
    return false;
}

Object.compare = function (obj1, obj2, console_log) {
	//Loop through properties in object 1
	for (var p in obj1) {
		//Check property exists on both objects
		if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
            console_log && console.error("hasOwnProperty");
            return false;
        }
        switch (typeof (obj1[p])) {
			//Deep compare objects
			case 'object':
                if (!Object.compare(obj1[p], obj2[p])) {
                    console_log && console.error(p);
                    return false;
                }
				break;
			//Compare function code
			case 'function':
				if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) {
                    console_log && console.error(p);
                    return false;
                }
				break;
			//Compare values
			default:
				if (obj1[p] != obj2[p]) {
                    console_log && console.error(p);
                    return false;
                }
		}
	}


    // Added allowing empty vs null vs undefined, because when we type in a field it will initialise it
    // in the array, and then if we delete the value again it will still be set to an empty string.
    // This loose comparison is fine for forms.

    // If obj1 is null then we check to see if obj2 is "empty" and we allow that.
    if(obj1 === null) {
        //console.error("" + obj2 + ":" + (obj2 !== "") +  (obj2 !== null));
        if(obj2 !== "" && obj2 !== null) {
            console_log && console.error("null check");
            return false;
        }
    }
    else {
        //Check object 2 for any extra properties
        for (var p in obj2) {
            // If we haven't got a matching property, we then check for "empty" and we allow that.
            if (typeof (obj1[p]) == 'undefined') {
                if(obj2[p] !== "" && obj2[p] !== null) {
                    console_log && console.error(p);
                    return false;
                }
            }
        }
    }
	return true;
};

Object.compare2 = (a, b) => {
    let s = o => Object.entries(o).sort().map(i => {
        if(i[1] instanceof Object) i[1] = s(i[1]);
        return i
    })
    return JSON.stringify(s(a)) === JSON.stringify(s(b))
}

Vue.prototype.checkUnsaved = function(original, updated, to, from, next) {
    if(!original) {
        // If we've nulled the original set we've essentially disabled the check.
        next();
        return;
    }
    var change = false;
    //console.info(JSON.stringify(original, null, 2));
    //console.info(JSON.stringify(updated, null, 2));

    // for(var key in original) {
    //     if(original[key] && typeof original[key] == "object" && original[key].value) {
    //         if(original[key].value != updated[key].value) {
    //             change = true;
    //         }
    //     }
    //     else if(original[key] != updated[key]) {
    //         console.error("Changed data: " + key + ": " + original[key] + ": " + updated[key]);
    //         change = true;
    //     }
    // }
    // console.info(change);

    change = !Object.compare(original, updated);

    if(change) {
        this.$modal.show('dialog', {
            title: this.$t('translations.unsaved_changes_title'),
            text: this.$t('translations.unsaved_changes_text'),
            buttons: [
            {
                title: this.$t('translations.yes'),
                handler: () => {
                    this.$modal.hide('dialog');
                    next();
                },
            },
            {
                title: this.$t('translations.cancel'),
                handler: () => {
                    this.$modal.hide('dialog');
                }
            }]});
    }
    else {
        next();
    }
}

Vue.prototype.appActive = function() {
    return this.$root.visibility === 'visible' & this.$root.focused;
}

Vue.prototype.appActiveAndConnected = function() {
    return this.appActive() & this.$root.connected;
}

Vue.prototype.getAppointmentSessionTypeUser = function(appointment) {
    if(appointment.appointment_session_type) {
        return appointment.appointment_session_type.user;
    }
    else if(appointment.app_app_session_type_xref && appointment.app_app_session_type_xref[0]) {
        return appointment.app_app_session_type_xref[0].appointment_session_type.user;
    }
    console.error(appointment);
    return {};
}

Vue.prototype.tIfExists = function (key, placeholders = false) {
    if(this.$i18n.keyExists(key)) {
        return this.$t(key, placeholders);
    }
    return key;
}

// @SYNC Helpers/Translation
Vue.prototype.tBrand = function (key, placeholders = false, inherit = true) {
    var domain = window.location.hostname.replace(/^[^.]*./, "").replace(/[-\.]/g, "_");
    var brand_key = `brand.${domain}.${key}`;
    //console.info(`tBrand: ${brand_key}`);
    if(this.$i18n.keyExists(brand_key)) {
        return this.$t(brand_key, placeholders);
    }
    if(inherit) {
        return this.tIfExists(`brand.base.${key}`, placeholders);
    }
    return key;
}

Vue.prototype.tBrandKey = function (key, placeholders = false, inherit = true) {
    var brand_keys = this.buildBrandKeys();
    var local_brand_keys = null;

    if(placeholders) {
        // Take a copy so that we don't polute the top level brand array with the additional elements
        local_brand_keys = Object.assign({}, brand_keys, elements);
    }
    else {
        local_brand_keys = brand_keys;
    }

    if(local_brand_keys[key]) {
        return local_brand_keys[key];
    }

    return key;
}

/**
 * Just a wrapper for now to call tBrandKey
 * @param {*} key 
 */
Vue.prototype.tBrandSetting = function (key) {
    var brand_key = this.tBrandKey(key);
    return brand_key == key ? false : brand_key;
}

// @SYNC Helpers/Translation
Vue.prototype.autobrand = function(key, elements) {
    var brand_keys = this.buildBrandKeys();
    var local_brand_keys = null;

    if(elements) {
        // Take a copy so that we don't polute the top level brand array with the additional elements
        local_brand_keys = Object.assign({}, brand_keys, elements);
    }
    else {
        local_brand_keys = brand_keys
    }
    //console.info(local_brand_keys);
    return this.tIfExists(key, local_brand_keys);
}

Vue.prototype.buildBrandKeys = function () {
    var domain = window.location.hostname.replace(/^[^.]*./, "").replace(/[-\.]/g, "_");
    var locale = Vue.i18n.locale();
    var provider = (this.$root.provider && this.$root.provider.id) ? this.$root.provider : {id: 0, name: ""};
    var brand_trans_key = `${provider.id}:${domain}:embed_${this.$root.embed}`;

    if(this.$root.lookup["brand_keys"] && this.$root.lookup["brand_keys"][brand_trans_key]) { 
        return this.$root.lookup["brand_keys"][brand_trans_key];
    }

    if(!this.$root.lookup["brand_keys"]) {
        this.$root.lookup["brand_keys"] = {};
    }

    // Note the difference here between JS and PHP versions. The brand is in the root in PHP,
    // but it is under "en" in JS. Annoying that, but it could allow us to do brand variations
    // for languages in the future (not that we should need that because of the way we handle the
    // keys), but ... .
    
    if(!locale || !window.Locales[locale].brand) {
        locale = "en";
    }
    
    this.$root.lookup["brand_keys"][brand_trans_key] = Object.assign({}, window.Locales[locale].brand.base, window.Locales[locale].brand[domain], window.Locales[locale].brand[`embed_${this.$root.embed}`]);
    this.$root.lookup["brand_keys"][brand_trans_key]["provider"] = provider.name;
    Object.keys(this.$root.lookup["brand_keys"][brand_trans_key]).forEach(bkey => {
        this.$root.lookup["brand_keys"][brand_trans_key][bkey] = this.tIfExists(this.$root.lookup["brand_keys"][brand_trans_key][bkey], this.$root.lookup["brand_keys"][brand_trans_key]);
        this.$root.lookup["brand_keys"][brand_trans_key][this.capitalise(bkey)] = this.capitalise(this.tIfExists(this.$root.lookup["brand_keys"][brand_trans_key][bkey], this.$root.lookup["brand_keys"][brand_trans_key]));
    });

    return this.$root.lookup["brand_keys"][brand_trans_key];
}

/**
 * Not very cool doing it this way, but it helps us with the transition to multilingual
 * as it means we can directly translate lookups both when they exist as a plain string
 * and when they are returned as a proper translation key.
 */
Vue.prototype.tIfExistsLazyLookup = function (key) {
    if(this.$i18n.keyExists(key)) {
        return this.$t(key);
    }
    else if(this.$i18n.keyExists("translations." + key)) {
        return this.$t("translations." + key);
    }
    
    return key;
}

Vue.prototype.translateLookup = function(lookup, nameField) {
    var translated = [];
    if(typeof nameField == "undefined") {
        nameField = "name";
    }
    if(Array.isArray(lookup)) {
        lookup.forEach((obj, index) => {
            if(typeof obj == "object") {
                translated.push({
                    id: obj.id,
                    name: this.tIfExistsLazyLookup(obj[nameField])
                })
            }
            else {
                translated.push({
                    id: index,
                    name: this.tIfExistsLazyLookup(obj)
                })
            }
            
        });
    }
    else if(typeof lookup == "object") {
        Object.keys(lookup).forEach(index => {
            translated.push({
                id: index, 
                name: this.tIfExistsLazyLookup(lookup[index])
            })
        });
    }
    return translated;
}

Vue.prototype.translateLookupItem = function(lookup, id, nameField) {
    var translated = this.translateLookup(lookup, nameField);
    var item = translated.find(obj => {return id == obj.id});
    if(item) {
        return item.name;
    }
    return null;
}


Vue.prototype.isOverlapping = function (start1, end1, start2, end2) {
    // if(!$start1->gt($end2) && !$start2->gt($end1)) {
    //     dump($start1);
    //     dump($end1);
    //     dump($start2);
    //     dump($end2);
    //     die();
    // }
    // console.info("isOverLapping1", !start1.isAfter(end2));
    // console.info("isOverLapping2", !start2.isAfter(end1));
    return !start1.isAfter(end2) && !start2.isAfter(end1);
}

Vue.prototype.hasSessionAvailabilityForSite = function(availability_dates, appointment_session_types, site_id) {
    var day = moment().format("YYYY-MM-DD"); 
    var found = false;
    availability_dates.forEach((availability_date) => {
        availability_date.availability_time.forEach((availability_time) => {
            //console.log(availability_time.site_id, site_id)
            if(availability_time.site_id == site_id) {
                appointment_session_types.forEach(appointment_session_type => {
                    appointment_session_type.appointment_session.forEach(appointment_session => {
                        var availabilityDayOfWeek = availability_date.date_from ? moment(availability_date.date_from).isoWeekDay : availability_date.day_of_week;
                        if(availabilityDayOfWeek == appointment_session.day_of_week) {
                            var start1, start2, end1, end2;
                            
                            start1 = moment(day + " " + availability_time.from);
                            end1 = moment(day + " " + availability_time.to);
                            start2 = moment(day + " " + appointment_session.start_at);
                            end2 = moment(day + " " + appointment_session.end_at);
                            
                            if(this.isOverlapping(start1, end1, start2, end2)) {
                                found = true;
                            }
                        }                        
                    });
                });
            }
        });
    });
    return found;
}

Vue.prototype.userHasSiteAvailability = function(user, site_id, date) {
    if(date) {
        var dayName = date.format("dddd").toLowerCase();
        var day = date.format("YYYY-MM-DD");

        if(Array.isArray(user.availability_date) && user.availability_date.length) {
            var availability_dates = user.availability_date.filter(obj => {
                var date_from = this.moment(obj.date_from, 'YYYY-MM-DD').format("YYYY-MM-DD");
                var date_to = this.moment(obj.date_to, 'YYYY-MM-DD').format("YYYY-MM-DD");

                return date_to ? (date_from <= day && date_to >= day) : (date_from == day);
                //return obj.date_to ? (obj.date_from <= day && obj.date_to >= day) : (obj.date_from == day);
            });
            if(!availability_dates.length) {
                availability_dates = user.availability_date.filter(obj => {return obj.date_from == dayName});
            }
            for(var index in availability_dates) {
                for(var dIndex in availability_dates[index].availability_time) {
                    if(availability_dates[index].availability_time[dIndex].site_id == site_id) {
                        return true;
                    }
                }
            }
        }
    }
    else {
        for(var index in user.availability_date) {
            for(var dIndex in user.availability_date[index].availability_time) {
                if(user.availability_date[index].availability_time[dIndex].site_id == site_id) {
                    return true;
                }
            }
        }
    }

    return false;
}

Vue.prototype.isMemberOfAssignableGroup = function(user) {
    for(var index in this.$root.lookup.user_groups) {
        if(this.$root.lookup.user_groups[index].members_assignable) {
            for(var userIndex in this.$root.lookup.user_groups[index].usersusergroup) {
                if(this.$root.lookup.user_groups[index].usersusergroup[userIndex].user_id == user.id) {
                    return true;
                }
            }
        }
    }
    return false;
}

window.getNavigatorLanguage = () => {
    var locale = 'en';

    if (navigator.languages && navigator.languages.length) {
        locale = navigator.languages[0];
    }
    else {
        locale = navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
    }

    locale = locale.replace(/-.*/, "");

    return locale;
};


Vue.prototype.listenWithChunking = function(channel, event, callback) {
    // Unchunked listener - We've removed this as we chunk everything, even single packets,
    // because it is easier, and cleaner. The original pusher example of this code
    // had a "chunked-" prefix on the second listener.
    //window.Echo.private(channel).listen(event, callback); // Allow normal unchunked events.

    // Now the chunked variation. Allows arbitrarily long messages.
    var events = {};
    window.Echo.private(channel).listen(event, data => {
        //console.warn(data);
        if (!events.hasOwnProperty(data.id)) {
            events[data.id] = { chunks: [], receivedFinal: false };
        }
        var ev = events[data.id];
        ev.chunks[data.index] = data.chunk;
        if (data.final) ev.receivedFinal = true;
        if (ev.receivedFinal && ev.chunks.length === Object.keys(ev.chunks).length) {
            callback(JSON.parse(ev.chunks.join("")));
            delete events[data.id];
        }
    });
};

Vue.prototype.objectPropKeysToAutocomplete = function(obj, id = "value", name = "name") {
    var objArray = [];
    
    Object.keys(obj).forEach(key => {
        if(obj[key] instanceof Object) {
            objArray.push({id: obj[key][id], name: this.tIfExists(obj[key][name])});
        }
        else {
            objArray.push({id: key, name: this.tIfExists(obj[key])});
        }});
    
    return objArray;
};

Vue.prototype.arrayToAutocomplete = function(array) {
    var objArray = [];
    
    array.forEach(key => {    
        objArray.push({id: key, name: this.tIfExists(key)});
    });
    
    return objArray;
};

Vue.prototype.selectorToAutocomplete = function(obj) {
    var objArray = [];
    
    Object.keys(obj).forEach(key => {
        objArray.push({id: obj[key], name: this.tIfExists(key)});
    });
    
    return objArray;
};

Vue.prototype.initEncryptStorage = function() {
    function testLocalStorage() {
        try {
            localStorage.setItem("test", "test");
            localStorage.removeItem("test");
            return true;
        } 
        catch(e) {
            return false;
        }
    }
    // Have we tested storage previously? null = no, false|true = yes
    if(this.$root.encryptStorage === null) {
        // Have we got the EncryptStorage module loaded and have a localStorage object
        if(!localStorage || !window.EncryptStorage) {
            this.$root.encryptStorage = false;
            console.info("initEncryptStorage: No localStorage or EncryptStorage available");
            return false;
        }
        
        // Can we actually store data in localStorage (Safari in private mode doesn't let you)
        if(!testLocalStorage()) {
            // Did the test fail because we have filled local storage?
            if(localStorage.length === 0) {
                console.info("initEncryptStorage: localStorage is not writeable (0 size, failed to write test item)");
                this.$root.encryptStorage = false;
                return false;
            }
            // Clear storage and attempt to write to localStorage again
            localStorage.clear();
            if(!testLocalStorage()) {
                console.info("initEncryptStorage: localStorage is still not writeable after being cleared");
                this.$root.encryptStorage = false;
                return false;
            }
        }
        
        // Finally if we have user data loaded (which we should) we initialise the encryption module.
        if(this.$root.user && this.$root.user.encryption_token) {
            this.$root.encryptPrefix = "els-" + window.environment_settings.MIX_CACHE_VERSION;
            this.$root.encryptStorage = new window.EncryptStorage(this.$root.user.encryption_token, {prefix: this.$root.encryptPrefix});
            console.info("initEncryptStorage: Initialised successfully");
        }
        else {
            console.info("initEncryptStorage: No user loaded yet. Will try again later");
        }
    }
    // else {
    //     console.warn("!!!!!", "Failed to set up encryptStorage");
    // }
};

Vue.prototype.cleanCache = function(name, suffix) {
    var prefixedName = this.$root.encryptPrefix + ":" + name;
    var fullName = prefixedName + (suffix ? ":" + suffix : "");

    for(var index in window.localStorage) {
        if(index == fullName) {
            return;
        }
    }
    
    var items = [];
    var item;
    for(var index in window.localStorage) {
        //console.info("Comparing", index, prefixedName)
        if(index.startsWith(prefixedName)) {
            try {
                //console.info("Adding", index, index.substr(this.$root.encryptPrefix.length));
                item = this.$root.encryptStorage.getItem(index.substr(this.$root.encryptPrefix.length + 1));
                items.push({index: index, data: item});
            }
            catch(e) {
                // If encryptStorage returns an error (usually Malformed UTF-8) then remove that broken storage item.
                console.warn("cleanCache: bad item found", index);
                window.localStorage.removeItem(index);
            }
        }
    }
    //console.info("Cleaning cache", items.length);
    //console.info("Cleaning cache", JSON.stringify(items, null ,2));
    if(items.length >= this.environment_settings.MIX_CACHE_MAX) {
        items.sort((item1, item2) => {
            if (item1.data.a < item2.data.a)
                return -1;
            if ( item1.data.a > item2.data.a)
                return 1;
            return 0;
        });
        console.info("Cleaning cache", JSON.stringify(items, null, 2));
        while(items.length >= this.environment_settings.MIX_CACHE_MAX) {
            item = items.shift();
            window.localStorage.removeItem(item.index);
        }
    }
}

Vue.prototype.eSetItem = function(name, value, suffix = null) {
    this.initEncryptStorage();
    if(this.$root.encryptStorage) {
        this.cleanCache(name, suffix);

        var suffixedName = name + (suffix ? ":" + suffix : "");

        
        try {
            this.$root.encryptStorage.setItem(suffixedName, {
                a: this.moment().unix(),
                data: value
            });
        }
        catch(error) {
			// If we fail to set the item, we have to remove the previous version we did save.
			// Otherwise this could be a safety issue especially with forms
			this.$root.encryptStorage.removeItem(suffixedName);
            // If it fails, ignore it. We don't want it reported in the usual error reporting.
        }

    }
    return null;
};

Vue.prototype.eGetItem = function(name, suffix) {
    var item = null;
    this.initEncryptStorage();
    if(this.$root.encryptStorage) {
        var suffixedName = name + (suffix ? ":" + suffix : "");
        try {
            item = this.$root.encryptStorage.getItem(suffixedName);
            if(item) {
                return item.data;
            }
        }
        catch(error) {
            // If the encryption key has changed, remove the item.
            this.eRemoveItem(suffixedName);
        }
    }
    return item;
};

Vue.prototype.eRemoveItem = function(name, suffix) {
    this.initEncryptStorage();
    if(this.$root.encryptStorage) {
        var suffixedName = name + (suffix ? ":" + suffix : "");
        //console.warn("Remove", fullName);
        this.$root.encryptStorage.removeItem(suffixedName);
    }
}
    
Vue.prototype.getTag = function(id) {
    var tag = this.$root.lookup.tags.find(obj => {return obj.id == id});
    if(tag) {
        return tag;
    }
    return {
        name: "",
        colour: "#1a72a0",
        icon: "",
    }
}

Vue.prototype.tagResultDisplay = function(item) {
    //console.info(item);
    return "<div class='search-lozenge-thin badge badge-primary badge-pill' style='background-color: " + item.colour + "'><i class='pr-1 fa fa-lg fa-" + item.icon + "'></i> " + item.name + "</div>";
}

Vue.prototype.registerGlobalListener = function(eventName, callback) {
    //console.log("CALLBACK ADDING: " + eventName + ": " + callback);
    if(!Array.isArray(this.$root.events[eventName])) {
        this.$root.events[eventName] = [];
    }
    this.$root.events[eventName].push(callback);
}

Vue.prototype.removeGlobalListener = function(eventName, callback) {
    if(Array.isArray(this.$root.events[eventName])) {
        this.$root.events[eventName].forEach((obj, index) => {
            if(obj == callback) {
                //console.log("CALLBACK REMOVING: " + eventName + ": " + callback);
                this.$root.events[eventName].splice(index, 1);
                
            }
        })
    }
    //this.$root.events[eventName].push(callback);
}

Vue.prototype.callGlobalListener = function(eventName, data) {
    //console.log("CALLBACK: " + eventName);
    if(Array.isArray(this.$root.events[eventName]) && this.$root.events[eventName].length) {
        //console.log("CALLING: " + this.$root.events[eventName][0]);
        this.$root.events[eventName][0](data);
    }
}

Vue.prototype.copyText = function(text) {
    if (navigator.clipboard){
        navigator.clipboard.writeText(text).then(() => {
            return true;
        })
        .catch(() => {
            
        });
    }    

    // Fallback to the old execCommand method (which is being deprecated)
    var container = document.createElement('div');
    container.innerHTML = text;
    document.body.appendChild(container);
    window.getSelection().removeAllRanges();

    var range = document.createRange();
    range.selectNode(container);
    window.getSelection().addRange(range);
    document.execCommand('copy');
    document.body.removeChild(container);
}

Vue.prototype.copyElementText = function(element) {
    var text_to_copy = document.getElementById("textcopy").innerHTML;

    if (navigator.clipboard){
        navigator.clipboard.writeText(text_to_copy).then(() => {
            return true;
        })
        .catch(() => {
            
        });
    }

    // Fallback to the old execCommand method (which is being deprecated)
    element.focus();
    element.select();
    document.execCommand("copy");    
}

Vue.prototype.has_record_system_integration = function() {
    return this.$root.provider.record_system_integration_type_id == 1;
}

Vue.prototype.getPlainAnswers = function(form_submission, content) {
    return this.reRenderPlainAnswers(content, form_submission.form ? form_submission.form.include_extended_field_data : true);
}

/**
 * Note that this function was originally written to split the head and body, so that we could render
 * it in various different forms in the MessageList components. However there have been many iterations
 * of the rendering now, and the plain_head parts were split again, to allow for different strong and em
 * options in the text. All looks a bit messy now, but it really is the most flexible way of doing it
 * to allow the other options (table, and bulletted list, both having been rejected now, despite the
 * table version being the best).
 * 
 * @param {*} content 
 * @param {*} include_extended_field_data 
 * @returns 
 */
Vue.prototype.reRenderPlainAnswers = function(content, include_extended_field_data) {
    var output = {};
    for (var index in content.readable) {
        var item = content.readable[index];

        if(typeof item.value != "undefined") {
            // Haven't got the questions here. We can load if we really really have to, but would rather not.
            var question = {};
            var questionName = index;
            output[questionName] = item;

            if(include_extended_field_data && item.name != item.title) {
                output[questionName].plain_head_title = item.title + (item.title.endsWith(":") ? " " : ": ");
                output[questionName].plain_head_extra = "(" + item.name + ")";
                output[questionName].plain_head = `${output[questionName].plain_head_extra} ${output[questionName].plain_head_title}`;
                
            }
            else {
                output[questionName].plain_head_title = item.name + (item.name.endsWith(":") ? " " : ": ");
                output[questionName].plain_head_extra = "";
                output[questionName].plain_head = output[questionName].plain_head_title;
            }
            
            output[questionName].plain_body = "";
                        
            if(typeof(item.value) == "string" && item.value.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)) {
                if(item.value) {
                    var date = this.moment(item.value)
                    if(date.isValid()) {
                        output[questionName].plain_body += date.format('DD/MM/YYYY');
                    }
                }
            }
            else if(Array.isArray(item.displayValue)) {
                var firstItem = true;
                for(var index in item.displayValue) {
                    if(!firstItem) {
                        output[questionName].plain_body += ", ";
                    }
                    else {
                        firstItem = false;
                    }
                    // This is an upload
                    if(item.displayValue[index].name && item.displayValue[index].type) {
                        output[questionName].plain_body += item.displayValue[index].name;
                    }
                    // Otherwise just display each element in the object
                    else {
                        output[questionName].plain_body += JSON.stringify(item.displayValue[index]);
                    }
                }

            }
            else if(typeof item.displayValue == "object") {
                var firstItem = true;
                for(var index in item.displayValue) {
                    if(!firstItem) {
                        output[questionName].plain_body += ", ";
                    }
                    else {
                        firstItem = false;
                    }
                    output[questionName].plain_body += index + " = " + item.displayValue[index];
                    if(include_extended_field_data && item.displayValue[index] != item.value[index]) {
                        output[questionName].plain_body += " [" + item.value[index] + "]";
                    }
                }
            }
            else {
                output[questionName].plain_body += item.displayValue;
                if(include_extended_field_data && item.displayValue != item.value) {
                    output[questionName].plain_body += " [" + item.value + "]";
                }
            }
            output[questionName].plain_head = output[questionName].plain_head.replace(/ *(___(AMG.*?)(?=___)___[, ]*)+/g, "").replace(/[([][)\]]/,"");
            output[questionName].plain_head_title = output[questionName].plain_head_title.replace(/ *(___(AMG.*?)(?=___)___[, ]*)+/g, "").replace(/[([][)\]]/,"");
            output[questionName].plain_head_extra = output[questionName].plain_head_extra.replace(/ *(___(AMG.*?)(?=___)___[, ]*)+/g, "").replace(/[([][)\]]/,"");
            output[questionName].plain_body = output[questionName].plain_body.replace(/ *(___(AMG.*?)(?=___)___[, ]*)+/g, "").replace(/[([][)\]]/,"");
        }
    }
    return output;
}